import React, { useState } from "react";
import "./styles.css";

function TextInput({
  type = "text",
  label,
  required,
  isError,
  onChange,
  value,
  name,
  pattern,
  seltectRequired,
  onBlur,
  maxLength
}) {
  return (
    <div className={!isError ? `input-container` : "error-container"}>
      <input
        type={type}
        value={value}
        onChange={onChange}
        name={name}
        onBlur={onBlur}
        maxLength={maxLength}
      />
      <label className={value && "filled"}>
        {label} {required && <span className="color-orange">*</span>}
        {seltectRequired && (
          <select>
            <option></option>
          </select>
        )}
      </label>
    </div>
  );
}
export default TextInput;
